import React from 'react';
import { Container, Row, Col, Card, Button, Nav } from 'react-bootstrap';
import CardGroup from 'react-bootstrap/CardGroup';
import { Link } from 'react-router-dom'; 
import Accordion from 'react-bootstrap/Accordion';
import Badge from 'react-bootstrap/Badge';
import ListGroup from 'react-bootstrap/ListGroup';
import Table from 'react-bootstrap/Table';


function Curso() {
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      const yOffset = -80; // Ajuste del offset, modifícalo según tus necesidades
      const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Container fluid>
      <Row>
        {/* Barra lateral scrollable */}
        <Col xs={2} md={2} className="bg-primary sidebar" style={{ position: 'fixed', top: 0, bottom: 0, overflowY: 'auto' }}>
          <br /><br /><br /><br /><br /><br /><br /><br />
          <Nav defaultActiveKey="/home" className="flex-column p-1" style={{ fontSize: '1.2rem' }}>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#home')}>
              Home
            </Nav.Link>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section1')}>
              Tarjeta con multilink
            </Nav.Link>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section2')}>
              Multilink y botón
            </Nav.Link>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section3')}>
              Objetivos de la certificación
            </Nav.Link>
            


            <Link to="/elementos" className="text-white nav-link">
              IR A OTRA PAGINA
            </Link>
            <Link to="/organigrama" className="text-white nav-link">
              CONVO
            </Link>
            
            
            
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section5')}>
              Option 5
            </Nav.Link>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section6')}>
              Option 6
            </Nav.Link>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section7')}>
              Option 7
            </Nav.Link>
            <Nav.Link className="text-white" onClick={(e) => handleScroll(e, '#section8')}>
              Option 8
            </Nav.Link>
          </Nav>
        </Col>

        {/* Contenido principal */}
     
        <Col xs={{ span: 9, offset: 3 }} md={{ span: 10, offset: 2 }} className="content">
        <div id='home'> <h6>Multilink y header</h6>
          <Row className="justify-content-center">
            <Card className="text-center" border="0">
              <Card.Img variant="top" src="**" alt="Imagen de ejemplo" />
              <Card.Body>
                <Card.Title>Formatos validados por la Dirección General de Imágen Institucional</Card.Title>
                <Card.Text>
                  Para su implementación dentro de la Secretaría de Gobierno 
                </Card.Text>
                <Card.Link href="#">Formato de Oficio</Card.Link>
                <Card.Link href="#">Formato de Portada</Card.Link>
                <Card.Link href="#">Formato de Resúmen Ejecutivo</Card.Link>
                <Card.Link href="#">Formato de Tarjeta Informativa</Card.Link>
                <Card.Link href="#">Formato de Tabla Excel</Card.Link>
                <br></br>
                <Button variant="primary" href="https://efinanzas.hidalgo.gob.mx/SIAUUV2/">Ir al oficio de validación</Button>
              </Card.Body>
              <Card.Footer className="text-muted">2 days ago</Card.Footer>
            </Card>
          </Row></div>
         
          <br></br><br></br>
<div id="section1">
          <h6>Tarjeta con multilink</h6>
          <Row className="justify-content-center">
            <Card style={{ width: '80rem' }} id="services"> {/* Sección de Servicios */}
              <Card.Body>
                <Card.Title>Servicios Ofrecidos</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">Subtitulo</Card.Subtitle>
                <Card.Text>
                  Centros de Atención
                </Card.Text>
                <Card.Link href="#">Link 1</Card.Link>
                <Card.Link href="#">Link 2</Card.Link>
                <Card.Link href="#">Link 3</Card.Link>
                <Card.Link href="#">Link 4</Card.Link>
                <Card.Link href="#">Link 5</Card.Link>
                <Card.Link href="#">Link 6</Card.Link>
                <Card.Link href="#">Link 7</Card.Link>
              </Card.Body>
            </Card>
          </Row>

          </div>


      <br></br><br></br>
      <div id="section2">
<h6>Multilink y botón</h6>
<Row className="justify-content-center">
  <Card className="text-center"> 
    <Card.Header>Prólogo</Card.Header>
    <Card.Body>
      <Card.Title>ISO</Card.Title>
      <Card.Text className="text-justify" style={{ textAlign: 'justify' }}>
        ISO (Organización Internacional de Normalización) es una federación mundial de organismos nacionales de normalización (organismos miembros de ISO). El trabajo de preparación de las normas internacionales normalmente se realiza a través de los comités técnicos de ISO. Cada organismo miembro interesado en una materia para la cual se haya establecido un comité técnico, tiene el derecho de estar representado en dicho comité. Las organizaciones internacionales, públicas y privadas, en coordinación con ISO, también participan en el trabajo. ISO colabora estrechamente con la Comisión Electrotécnica Internacional (IEC) en todas las materias de normalización electrotécnica.
        En la parte 1 de las Directivas ISO/IEC se describen los procedimientos utilizados para desarrollar esta norma y para su mantenimiento posterior. En particular debería tomarse nota de los diferentes criterios de aprobación necesarios para los distintos tipos de documentos ISO. Esta norma se redactó de acuerdo con las reglas editoriales de la parte 2 de las Directivas ISO/IEC (véase www.iso.org/directives).<br></br><br></br>
      </Card.Text>
      <Card.Link href="#">Ir a la lección 1</Card.Link>
      <Card.Link href="#">Ir a la lección 2</Card.Link>
      <Card.Link href="#">Ir a la lección 3</Card.Link>
      <Card.Link href="#">Ir a la lección 4</Card.Link>
      <br></br>
      <Button variant="primary" href="https://efinanzas.hidalgo.gob.mx/SIAUUV2/">Ir al material de apoyo</Button>
    </Card.Body>
    <Card.Footer className="text-muted">Despacho de la Secretaría de Gobierno del Estado de Hidalgo</Card.Footer>
  </Card>
</Row>
</div>




      <br></br><br></br>
      <h6>Objetivos de la certificación</h6>
      <CardGroup>
      <Card>
        <Card.Img variant="top" src="https://lh3.googleusercontent.com/-Rf58WLMclMQ/UmXuvmvLv-I/AAAAAAAAOmU/gvJFQIctFSM/s364/modernizar-empresa.jpg" />
        <Card.Body>
          <Card.Title>Mejorar</Card.Title>
          <Card.Text>
            This is a wider card with supporting text below as a natural lead-in
            to additional content. This content is a little bit longer.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <small className="text-muted">Last updated 3 mins ago</small>
        </Card.Footer>
      </Card>
      <Card>
        <Card.Img variant="top" src="https://gmpitconsulting.com.ar/wp-content/uploads/2017/04/Modernizar.jpg" />
        <Card.Body>
          <Card.Title>Modernizar</Card.Title>
          <Card.Text>
            This is a wider card with supporting text below as a natural lead-in
            to additional content. This content is a little bit longer.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <small className="text-muted">Last updated 3 mins ago</small>
        </Card.Footer>
      </Card>
      <Card>
        <Card.Img variant="top" src="https://media.licdn.com/dms/image/C4D12AQHY0wKkgEmy9A/article-cover_image-shrink_600_2000/0/1559931924212?e=2147483647&v=beta&t=db9ZGw7d_pKBc09buBhgnT8RhxO6L2HhDSqNWKcSIJ8" />
        <Card.Body>
          <Card.Title>Eficientizar</Card.Title>
          <Card.Text>
            This card has supporting text below as a natural lead-in to
            additional content.{' '}
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <small className="text-muted">Last updated 3 mins ago</small>
        </Card.Footer>
      </Card>
      <Card>
        <Card.Img variant="top" src="https://s-gobierno.hidalgo.gob.mx/Img/defensoria.png" />
        <Card.Body>
          <Card.Title>Card title</Card.Title>
          <Card.Text>
            This is a wider card with supporting text below as a natural lead-in
            to additional content. This card has even longer content than the
            first to show that equal height action.
          </Card.Text>
        </Card.Body>
        <Card.Footer>
          <small className="text-muted">Last updated 3 mins ago</small>
        </Card.Footer>
      </Card>
    </CardGroup>


    <div id="section4">
    <br></br><br></br>
    <h6>Acordeón</h6>
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>Accordion Item #1</Accordion.Header>
        <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
       
        </Accordion.Body>
      </Accordion.Item>
      
      <Accordion.Item eventKey="1">
        <Accordion.Header>Accordion Item #2</Accordion.Header>
        <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="2">
        <Accordion.Header>Accordion Item #2</Accordion.Header>
        <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="3">
        <Accordion.Header>Accordion Item #2</Accordion.Header>
        <Accordion.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
         
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
</div>





    <br></br><br></br>
    <h6>List Group</h6>
    <ListGroup as="ol" numbered>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >
        <div className="ms-2 me-auto">
          <div className="fw-bold">Subheading</div>
          Cras justo odio
        </div>
        <Badge bg="primary" pill>
          14
        </Badge>
      </ListGroup.Item>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >
        <div className="ms-2 me-auto">
          <div className="fw-bold">Subheading</div>
          Cras justo odio
        </div>
        <Badge bg="primary" pill>
          14
        </Badge>
      </ListGroup.Item>
      <ListGroup.Item
        as="li"
        className="d-flex justify-content-between align-items-start"
      >
        <div className="ms-2 me-auto">
          <div className="fw-bold">Subheading</div>
          Cras justo odio
        </div>
        <Badge bg="primary" pill>
          14
        </Badge>
      </ListGroup.Item>
    </ListGroup>





    <br></br><br></br>
    <h6>Tablas</h6>
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          <th>#</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Username</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Mark</td>
          <td>Otto</td>
          <td>@mdo</td>
        </tr>

        <tr>
          <td>2</td>
          <td>Jacob</td>
          <td>Thornton</td>
          <td>@fat</td>
        </tr>

        <tr>
          <td>3</td>
          <td>Jacob</td>
          <td>Thornton</td>
          <td>@fat</td>
        </tr>

        <tr>
          <td>4</td>
          <td>Jacob</td>
          <td>Thornton</td>
          <td>@fat</td>
        </tr>

      </tbody>
    </Table>







    </Col>
      </Row>
    </Container>
  );
}

export default Curso;
